import React, { createElement } from 'react';
import { Hero } from './components/Hero';
import { WhatIsEbook } from './components/WhatIsEbook';
import { Problem } from './components/Problem';
import { Revelation } from './components/Revelation';
import { Benefits } from './components/Benefits';
import { BookDescription } from './components/BookDescription';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { WhatYouGet } from './components/WhatYouGet';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-matrix-black text-matrix-white font-inter selection:bg-matrix-green selection:text-matrix-black" data-id="element-0">
      <Hero data-id="element-1" />
      <WhatIsEbook data-id="element-2" />
      <Problem data-id="element-3" />
      <Revelation data-id="element-4" />
      <Benefits data-id="element-5" />
      <BookDescription data-id="element-6" />
      <Testimonials data-id="element-7" />
      <CTA data-id="element-8" />
      <WhatYouGet data-id="element-9" />
      <PricingCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}